module.exports = require("./dist/inputmask");



//////////////////
// WEBPACK FOOTER
// /var/www/fabrikanoskov.ru/data/www/fabrikanoskov.ru/web/app/themes/sage/node_modules/inputmask/index.js
// module id = 42
// module chunks = 0